import api from "@/shared/services/apiClient";
import type { CompanyData } from "@/shared/types/common";

export const companyService = {
  getDropdown: async (feature?: "ticketing" | "flight_tracker" | "company_form") => {
    const res = await api.get("/company/dropdown", { params: feature ? { feature } : undefined });
    return res.data;
  },

  getAll: async () => {
    const res = await api.get("/company/list");
    return res.data;
  },

  create: async (data: CompanyData) => {
    const res = await api.post("/company/create", data);
    return res.data;
  },

  update: async (id: string, data: Partial<CompanyData>) => {
    const res = await api.put(`/company/update/${id}`, data);
    return res.data;
  },

  delete: async (id: string) => {
    const res = await api.delete(`/company/delete/${id}`);
    return res.data;
  },

  getEmployeesByCompany: async (companyId: string) => {
    const res = await api.get(`/company/${companyId}/employees`);
    return res.data;
  },

  getRegistrationCodes: async (companyId: string) => {
    const res = await api.get(`/company/${companyId}/registration-codes`);
    return res.data;
  },

  getCoordinatorOptions: async () => {
    const res = await api.get("/company/coordinator-options");
    return res.data as { value: string; label: string }[];
  },
};
